import "core-js/modules/es.array.concat.js";
import React from 'react';
import getImageUrlSuffix from 'utils/image/getImageUrlSuffix';
import useBreakpoints from 'hooks/useBreakpoints';
import AssetIcon from 'components/AssetIcon';
import Box from 'components/Box';
import Card from 'components/Card';
import CardImage from 'components/CardImage';
import CenterContent from 'components/CenterContent';
var maxPlayerWidth = 720;
var pictureUrlSuffix = getImageUrlSuffix({
  width: maxPlayerWidth
});
function AudioPlayerWrapper(props) {
  var icon = props.icon,
    pictureUrl = props.pictureUrl,
    children = props.children;
  var _useBreakpoints = useBreakpoints(),
    isDesktop = _useBreakpoints.xs;
  return /*#__PURE__*/React.createElement(CenterContent, {
    contentWidth: maxPlayerWidth,
    fillParent: isDesktop,
    height: isDesktop ? null : 200
  }, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardImage, {
    lazyload: false,
    src: pictureUrl && "".concat(pictureUrl).concat(pictureUrlSuffix),
    colorBlock: icon,
    aspectRatio: 2 / 3,
    fallbackContent: /*#__PURE__*/React.createElement(AssetIcon, {
      name: icon,
      size: "big"
    })
  }), /*#__PURE__*/React.createElement(Box, {
    pr: "s"
  }, children)));
}
export default AudioPlayerWrapper;